export default {
  default: () => import("/builds/webcontact/rheinau/layouts/default.vue")
}